import { Box, Text } from '@mantine/core';

function PlayerDrawing({ src, alt = 'Player drawing', size = 200, playerName, style = {} }) {
  return (
    <Box style={{ position: 'relative', flexShrink: 0, ...style }}>
      {playerName && (
        <Text
          style={{
            textAlign: 'center',
            fontWeight: 700,
            fontSize: `${size * 0.016}rem`,
            color: '#222',
            textShadow: '1px 1px 0px rgba(255,255,255,0.8)',
            marginBottom: 4,
            whiteSpace: 'nowrap',
            maxWidth: size,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {playerName}
        </Text>
      )}
      <Box
        style={{
          width: size,
          height: size,
          borderRadius: 12,
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          backgroundColor: 'white',
        }}
      >
        <img
          src={src}
          alt={alt}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </Box>
    </Box>
  );
}

export default PlayerDrawing;
